import {
    Box,
    Divider,
    IconCheckedFilled,
    IconCheckedRegular,
    Stack,
    Text1,
    Text2,
    Text3,
    TextLink,
    skinVars,
} from '@telefonica/mistica';
import React from 'react';
import { IStepperTimeLineIssue } from '../../models/Problems.interfaces';
import { getFormatDate } from '../../utils/dataTransformation/dateConversions';
import './index.scss';
import navigateParams from '../../utils/navigation/navigateParams';
import { useTranslation } from 'react-i18next';

export const StepperBullet: React.FC<{ bullets: IStepperTimeLineIssue[] }> = ({
    bullets,
}: {
    bullets: IStepperTimeLineIssue[];
}) => {
    const { t } = useTranslation();
    const literal: { [key: string]: { title: string; subtitle?: string; isLink?: boolean } } = {
        'Abrir problema': {
            title: 'Incidencia abierta',
            subtitle: 'Estamos trabajando para solucionar tu incidencia lo antes posible.',
        },
        'Problema en diagnóstico. Pendiente de cliente': {
            title: 'Continúa con el autodiagnóstico',
            subtitle:
                'Dispones de 48h para retomar el diagnóstico de tu incidencia. Pasado ese tiempo, ya no será posible y deberás abrir una nueva.',
        },
        'Diagnosticar problema': {
            title: 'En revisión por equipo técnico',
            subtitle: 'Estamos analizando tu incidencia. Si es necesario, un técnico se pondrá en contacto contigo.',
        },
        'Envío solicitud a Fuerza de Trabajo': {
            title: 'Requiere visita técnica',
            subtitle:
                'Es necesario que un tecnico acuda a tu domicilio para solucionar tu incidencia. Te llamaremos para concertar la cita.',
        },
        'Visita técnica concertada': {
            title: 'Visita técnica concertada',
            subtitle: bullets.filter(
                ({ descriptionType }: IStepperTimeLineIssue) => descriptionType === 'Visita técnica concertada',
            )[0]?.customerComments,
        },
        'Dispositivo enviado': {
            title: 'Dispositivo enviado',
            subtitle: bullets.filter(
                ({ descriptionType }: IStepperTimeLineIssue) => descriptionType === 'Dispositivo enviado',
            )[0]?.customerComments,
            isLink: true,
        },
        'Envío solicitud a Logística': {
            title: 'Requiere nuevo dispositivo',
            subtitle:
                'Es necesario cambiar tu dispositivo. Te enviaremos uno nuevo a tu domicilio en los próximos días',
        },
        'Solicitar cancelación problema': {
            title: 'Cancelación solicitada',
        },
        'TT cancelado. Cancelar problema de cliente': {
            title: 'Incidencia cancelada',
        },
        'Cerrar problema': {
            title: 'Incidencia finalizada',
            subtitle: 'Hemos cerrado tu incidencia.',
        },
        'Anular problema': {
            title: 'Incidencia cancelada',
        },
        'Cliente no conforme. Propuesta no aceptada': {
            title: 'Incidencia reabierta',
            subtitle: 'Estamos analizando de nuevo el problema.',
        },
    };

    const getIconBullet = (index: number) =>
        index === 0 ? (
            <IconCheckedFilled color={skinVars.colors.controlActivated}></IconCheckedFilled>
        ) : (
            <IconCheckedRegular color={skinVars.colors.controlActivated}></IconCheckedRegular>
        );

    const handleDate = (date: string) => {
        const isToday = new Date(date).toDateString() === new Date().toDateString();
        return isToday
            ? `${new Date(date).getHours()}:${new Date(date).getMinutes().toString().padStart(2, '0')}`
            : getFormatDate(new Date(date), 'DD/MM/YYYY');
    };

    const isLiteralDefine = (descriptionType: string) => {
        return Object.keys(literal).includes(descriptionType);
    };

    const handleTraductionTask = (item: IStepperTimeLineIssue) => {
        return literal[item.descriptionType];
    };

    const sendToNative = (url: string, type: string, title: string) => {
        const queryParams = {};
        const storage = {};
        if (navigateParams(type, url, queryParams, storage, title)) {
            window.open(url, '_blank');
        }
    };

    const listTasksFinal = () =>
        bullets!.filter((item: IStepperTimeLineIssue) => isLiteralDefine(item.descriptionType));

    return (
        <>
            {listTasksFinal().map((task: IStepperTimeLineIssue, index: number) => {
                const { date, descriptionType } = task;
                return (
                    <Box key={index}>
                        <div className={`stepper-bullet  ${index === listTasksFinal()?.length - 1 ? 'last' : ''}`}>
                            <div className='stepper-bullet-container'>
                                <div className='stepper-bullet-icon'>
                                    {getIconBullet(index)}
                                    <div
                                        className='stepper-bullet-line'
                                        style={{
                                            display: listTasksFinal().length - 1 === index ? 'none' : 'block',
                                            background: skinVars.colors.controlActivated,
                                        }}
                                    ></div>
                                </div>
                                <Stack space={0}>
                                    <div
                                        className='stepper-bullet-title'
                                        style={{ paddingTop: index !== 0 ? '5px' : '' }}
                                    >
                                        <Text3 regular>{handleTraductionTask(task)?.title || descriptionType}</Text3>
                                    </div>
                                    <div className='stepper-bullet-time'>
                                        <Text1 regular>{handleDate(date)}</Text1>
                                    </div>
                                    <div className='stepper-bullet-text'>
                                        {handleTraductionTask(task).isLink ? (
                                            <TextLink
                                                onPress={() => {
                                                    sendToNative(
                                                        `https://${handleTraductionTask(task)?.subtitle!}`,
                                                        'modeExternal',
                                                        handleTraductionTask(task)?.subtitle!,
                                                    );
                                                }}
                                            >
                                                {t('urlZelerisText')}
                                            </TextLink>
                                        ) : (
                                            <Text2 regular color={skinVars.colors.textSecondary}>
                                                {handleTraductionTask(task)?.subtitle}
                                            </Text2>
                                        )}
                                    </div>
                                    <div className='stepper-bullet-divider'>
                                        {index !== listTasksFinal().length - 1 ? <Divider></Divider> : null}
                                    </div>
                                </Stack>
                            </div>
                        </div>
                    </Box>
                );
            })}
        </>
    );
};
export default StepperBullet;
